import { Entity, Column, PrimaryGeneratedColumn } from "typeorm";

@Entity()
export class GpsCoordinatesEntity {

    @PrimaryGeneratedColumn()
    gpsCoordId: number;

    @Column("decimal", { nullable:true,precision: 17, scale: 15 })
    gpsLatitude: number;

    @Column("decimal", { nullable:true,precision: 17, scale: 15 })
    gpsLongitude: number;
}